import { Directive, Host, OnDestroy, OnInit } from '@angular/core';
import { DropdownComponent } from '@appkit4/angular-components/dropdown';

/**
 * AppKit ap-dropdown scrolls the selected option into view when the list is
 * opened with the mouse. That scroll is scheduled twice after show():
 * getActiveItemId waits 100ms, then normalDataScroll/groupDataScroll waits
 * another 300ms. A one-shot flag is consumed by whichever call runs first, so
 * the later call still jumps the list. This attribute suppresses those open
 * scrolls for the whole delay. The selected option keeps its active highlight
 * and the list stays at the top. Keyboard navigation after the list has opened
 * still scrolls the focused option into view.
 */
@Directive({
  selector: 'ap-dropdown[noScrollOnOpen]',
  standalone: false,
})
export class AppkitDropdownNoScrollOnOpenDirective implements OnInit, OnDestroy {
  private suppressTimer: ReturnType<typeof setTimeout> | undefined;

  constructor(@Host() private readonly dropdown: DropdownComponent) {}

  ngOnInit(): void {
    const instance = this.dropdown as unknown as {
      show: () => void;
      normalDataScroll: () => void;
      groupDataScroll: () => void;
    };
    const show = instance.show.bind(instance);
    const normalDataScroll = instance.normalDataScroll.bind(instance);
    const groupDataScroll = instance.groupDataScroll.bind(instance);
    let suppressScroll = false;

    instance.show = () => {
      suppressScroll = true;
      clearTimeout(this.suppressTimer);
      show();
      this.suppressTimer = setTimeout(() => {
        suppressScroll = false;
      }, 500);
    };
    instance.normalDataScroll = () => {
      if (!suppressScroll) {
        normalDataScroll();
      }
    };
    instance.groupDataScroll = () => {
      if (!suppressScroll) {
        groupDataScroll();
      }
    };
  }

  ngOnDestroy(): void {
    clearTimeout(this.suppressTimer);
  }
}
